import { render, staticRenderFns } from "./Officialaccount.vue?vue&type=template&id=ca49f4aa&scoped=true"
import script from "./Officialaccount.vue?vue&type=script&lang=js"
export * from "./Officialaccount.vue?vue&type=script&lang=js"
import style0 from "./Officialaccount.vue?vue&type=style&index=0&id=ca49f4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca49f4aa",
  null
  
)

export default component.exports